import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class ShowHistoricalSearchService {
    constructor() {
        this.showHistoricalSubject = new BehaviorSubject([]);
        this.showHistoricalRespSubject = new BehaviorSubject([]);
        this.setSeacherFormSubject = new BehaviorSubject([]);
        this.getSeacherFormRespSubject = new BehaviorSubject([]);
        this.testObservable = this.showHistoricalSubject.asObservable();
        this.shistoricalRespObservable = this.showHistoricalRespSubject.asObservable();
        this.formObservable = this.setSeacherFormSubject.asObservable();
        this.showHistoricalRespObservable = this.getSeacherFormRespSubject.asObservable();
    }
    setShowHistoricalSearch(dataTest) {
        this.showHistoricalSubject.next(dataTest);
    }
    getShowHistoricalSearch() {
        return this.testObservable;
    }
    setFormSearcherSearch(dataForm) {
        this.setSeacherFormSubject.next(dataForm);
    }
    getFormSearcherSearch() {
        return this.formObservable;
    }
}
ShowHistoricalSearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShowHistoricalSearchService_Factory() { return new ShowHistoricalSearchService(); }, token: ShowHistoricalSearchService, providedIn: "root" });
